<template>
  <!-- Пузырь ленты (p4): свои справа серые с именем, поддержка слева кремовые с аватаром -->
  <div :id="`message-${message.id}`" class="bubble-row" :class="{ 'bubble-row--own': own }">
    <support-avatar
      v-if="!own"
      class="bubble-row__avatar"
      :src="avatar"
      :srcset="avatarSrcset"
      :name="message.author && message.author.name"
      :size="32"
    />
    <div
      class="bubble"
      :class="{ 'bubble--own': own, 'bubble--highlight': highlighted }"
      @contextmenu.prevent="$emit('menu', { message, attachment: null, event: $event })"
    >
      <!-- Ответ с цитатой: клик ведёт к оригиналу -->
      <button
        v-if="message.replyTo"
        type="button"
        class="bubble__quote"
        @click="$emit('quote', message.replyTo.id)"
      >
        <img
          v-if="message.replyTo.thumbUrl"
          class="bubble__quote-thumb"
          :src="message.replyTo.thumbUrl"
          alt=""
        >
        <span class="bubble__quote-text">
          <span class="bubble__quote-author">{{ message.replyTo.authorName }}</span>
          <span class="bubble__quote-preview">{{ quote }}</span>
        </span>
      </button>

      <photo-album
        v-if="message.attachments.length"
        :attachments="message.attachments"
        class="bubble__photos"
        @menu="$emit('menu', { message, ...$event })"
        @open="$emit('photo', { photos: message.attachments, index: $event })"
      />

      <!-- v-text: без пробелов шаблона, их видно при pre-wrap -->
      <div v-if="message.text" class="bubble__text" v-text="message.text" />
      <div class="bubble__meta">
        {{ meta }}
      </div>
    </div>
  </div>
</template>

<script>
  import PhotoAlbum from './PhotoAlbum.vue'
  import SupportAvatar from '../SupportAvatar.vue'
  import { clock } from '../format'
  import { quotePreview } from '../feed'
  import systemAvatar from '@/assets/support/avatar-fakt-support.png'
  import systemAvatar2x from '@/assets/support/avatar-fakt-support@2x.png'

  export default {
    name: 'MessageBubble',
    components: { PhotoAlbum, SupportAvatar },
    props: {
      message: { type: Object, required: true },
      highlighted: { type: Boolean, default: false },
    },
    computed: {
      own () {
        return this.message.from === 'branch'
      },
      // Автоответ и благодарность за идею - от «Поддержка FAKT» с аватаром FS.
      avatar () {
        return this.message.from === 'system' ? systemAvatar : this.message.author?.avatar
      },
      avatarSrcset () {
        return this.message.from === 'system' ? `${systemAvatar2x} 2x` : null
      },
      // Филиал пишет сменой: имя автора внутри своего пузыря всегда; у поддержки - только время.
      meta () {
        const time = clock(this.message.createdAt)

        return this.own ? `${this.message.author?.name} · ${time}` : time
      },
      quote () {
        return quotePreview(this.message.replyTo.preview, 80) || 'Фото'
      },
    },
  }
</script>

<style scoped lang="less">
@import '../tokens.less';

.bubble-row {
  display: flex;
  gap: 10px;
  align-items: flex-end;

  &--own {
    justify-content: flex-end;
  }
}

.bubble {
  max-width: 460px;
  padding: 12px 14px 8px;
  border: 1px solid @fakt-divider;
  border-radius: @fakt-radius-bubble-in;
  color: @fakt-text;
  background: @fakt-bubble-peer;
  transition: box-shadow 0.3s ease;

  &--own {
    max-width: 448px;
    border-radius: @fakt-radius-bubble-out;
    background: @fakt-surface;
  }

  // Подсветка оригинала после клика по цитате
  &--highlight {
    box-shadow: 0 0 0 2px @fakt-orange;
  }
}

.bubble__quote {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
  margin-bottom: 8px;
  padding: 6px 8px;
  border-left: 3px solid @fakt-orange;
  border-radius: 4px;
  text-align: left;
  background: rgba(0, 0, 0, .04);
}

.bubble__quote-thumb {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 4px;
  object-fit: cover;
}

.bubble__quote-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  font-size: 13px;
}

.bubble__quote-author {
  font-weight: 500;
  color: @fakt-orange;
}

.bubble__quote-preview {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: @fakt-text-2;
}

.bubble__photos {
  margin-bottom: 8px;
}

.bubble__text {
  font-size: 14px;
  line-height: 20px;
  white-space: pre-wrap;
  word-break: break-word;
}

.bubble__meta {
  margin-top: 4px;
  font-size: 11px;
  text-align: right;
  color: @fakt-text-3;
}
</style>
